var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlyingSaucer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2094 12.5309L11.4684 14.0981",
    stroke: "#8C93A3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12.75V14.875",
    stroke: "#8C93A3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79063 12.5309L5.53165 14.0981",
    stroke: "#8C93A3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7539 4.56875C14.2309 5.08672 15.9375 6.17578 15.9375 7.4375C15.9375 9.19726 12.6105 10.625 8.5 10.625C4.38945 10.625 1.0625 9.19726 1.0625 7.4375C1.0625 6.17578 2.78242 5.08008 5.27266 4.56875",
    stroke: "#8C93A3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78126 6.63398C4.7802 6.87383 4.86134 7.1068 5.01117 7.29408C5.161 7.48137 5.37047 7.61167 5.6047 7.66328C6.55492 7.87567 7.52639 7.97816 8.50001 7.96875C9.47363 7.97816 10.4451 7.87567 11.3953 7.66328C11.6296 7.61167 11.839 7.48137 11.9889 7.29408C12.1387 7.1068 12.2198 6.87383 12.2188 6.63398V6.375C12.2188 5.88271 12.1211 5.39531 11.9313 4.94108C11.7415 4.48684 11.4634 4.07481 11.1132 3.72887C10.7629 3.38294 10.3475 3.11 9.89091 2.92587C9.43435 2.74174 8.94578 2.6501 8.45353 2.65625C6.40821 2.68281 4.78126 4.38945 4.78126 6.42812V6.63398Z",
    stroke: "#8C93A3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlyingSaucer);
export default __webpack_public_path__ + "static/media/FlyingSaucer.8708f35bbd3b5e01e4be0f4dd378dca1.svg";
export { ForwardRef as ReactComponent };